import ko from 'knockout';
import _ from 'underscore';
import { generate } from './readonly-computed';

/**
 * extend the text observable
 * @param {Observable} local - observable define for property
 * @param {Object} attrs - property define
 * @param {FieldOption} fieldOption - field of property
 * @param {Object} viewModel - model value of entity
 * @returns {undefined} - the function extend passed local directly
 */
export function text(local, attrs, fieldOption, viewModel) {
  const { id } = fieldOption;

  _.extend(local, {
    text: local.string ? local.string : local,
    placeholder: generate(fieldOption.placeholder, viewModel),
    describedby: ko.observableArray([`${id}-Remaining`, `${id}-Validation`]),
  });


  _.extend(local, {
    strDescribedby: ko.computed(() => {
      const by = local.describedby() || [];

      return by.join(' ');
    }),
  });
}
